

<ng-template #template>

  <ng-container *ngIf="missedCallsByGroup | async as _missedCallsByGroup; else (loading$ | async)">
    <stacked-bar-chart *ngIf="_missedCallsByGroup.length > 0 else (noResults$ | async)"
                       [results]="_missedCallsByGroup"
                       [options]="missedCallsByGroupOptions"
                       (select)="onSelect($event)">
    </stacked-bar-chart>
  </ng-container>
</ng-template>


